import { NON_CATEGORY_SLUG } from '@/configs';

export const getCoursePagePath = (
  slug: string,
  categorySlug: string = NON_CATEGORY_SLUG,
) => `/${categorySlug}/${slug}`;
